'use client';

import { createAuthProvider } from '@org/auth-next/client';

const { AuthProvider, useAuth, useAuthStatus, useCurrentUser } = createAuthProvider();

export { AuthProvider, useAuth, useAuthStatus, useCurrentUser };
